import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Study } from '../../../models/study';
import { UploadIds } from 'src/app/models/upload';
import { ApiService } from '../../../core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class StudyService {
  getStudies(): Observable<Study[]> {
    return this.apiService.get<Study[]>(`/dashboard/studies`);
  }

  getStudiesForOverview(page = 1): Observable<any> {
    return this.apiService.get(`/dashboard/studies-overview?page=` + page);
  }

  getStudyById(studyId: number): Observable<Study> {
    return this.apiService.get<Study>(`/dashboard/study/${studyId}`);
  }

  searchStudy(query: string, filter: string): Observable<Study[]> {
    if (query.length > 0) {
      return this.apiService.get<Study[]>(`/dashboard/study/search/${query}?filter=${filter}`);
    } else {
      return this.apiService.get<Study[]>(`/dashboard/study/search?filter=${filter}`);
    }
  }

  uploadStudyImage(imageFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string[]>> {
    const body: FormData = new FormData();
    body.append('uploads[]', imageFile, imageFile.name);
    return this.apiService.post<HttpEvent<string[]>>(`/dashboard/study/${idsForUpload?.studyId || 0}/upload`, body, {
      reportProgress: true,
      observe: 'events',
    });
  }

  createStudy(study: Study): Observable<Study> {
    return this.apiService.post<Study>(`/dashboard/study`, study);
  }

  updateStudy(study: Study): Observable<Study> {
    return this.apiService.put<Study>(`/dashboard/study/${study.id}`, study);
  }

  deleteStudy(study: Study): Observable<void> {
    return this.apiService.delete<void>(`/dashboard/study/${study.id}`);
  }

  duplicateStudy(study: Study): Observable<Study> {
    return this.apiService.post<Study>(`/dashboard/study/${study.id}`, study);
  }

  constructor(private apiService: ApiService) {}
}
